/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamAuthorDropdownQueryResponse,
  GetApiV1ExamAuthorDropdownQueryParams,
  GetApiV1ExamAuthorDropdown400,
  GetApiV1ExamAuthorDropdown401,
  GetApiV1ExamAuthorDropdown500,
} from "../../types/examSharedController/GetApiV1ExamAuthorDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamAuthorDropdown } from "../../clients/examSharedController/getApiV1ExamAuthorDropdown.ts";

export const getApiV1ExamAuthorDropdownQueryKey = (
  params?: GetApiV1ExamAuthorDropdownQueryParams,
) =>
  [
    { url: "/api/v1/exam/author-dropdown" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamAuthorDropdownQueryKey = ReturnType<
  typeof getApiV1ExamAuthorDropdownQueryKey
>;

export function getApiV1ExamAuthorDropdownQueryOptions(
  params?: GetApiV1ExamAuthorDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamAuthorDropdownQueryKey(params);
  return queryOptions<
    GetApiV1ExamAuthorDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamAuthorDropdown400
      | GetApiV1ExamAuthorDropdown401
      | GetApiV1ExamAuthorDropdown500
    >,
    GetApiV1ExamAuthorDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamAuthorDropdown(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de autores (monitores, gestores e professores) para uso em componentes de seleção. Quando informado o companyId, retorna apenas pessoas com perfil correspondente naquela empresa; caso contrário, retorna monitores e corpo docente ativos. Aceita filtro por nome ou ID. **(Requer Authorization para autenticação)**
 * @summary Lista de autores para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/author-dropdown}
 */
export function useGetApiV1ExamAuthorDropdown<
  TData = GetApiV1ExamAuthorDropdownQueryResponse,
  TQueryData = GetApiV1ExamAuthorDropdownQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamAuthorDropdownQueryKey,
>(
  params?: GetApiV1ExamAuthorDropdownQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamAuthorDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamAuthorDropdown400
          | GetApiV1ExamAuthorDropdown401
          | GetApiV1ExamAuthorDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamAuthorDropdownQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamAuthorDropdownQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamAuthorDropdown400
      | GetApiV1ExamAuthorDropdown401
      | GetApiV1ExamAuthorDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
